import * as Styles from "./Loading.styles";

export function Loading() {
  return (
    <Styles.Wrapper>
      <Styles.Inner>LOADING</Styles.Inner>
    </Styles.Wrapper>
  );
}
